function escapeCell(value: string | number): string {
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function rowsToCsv(rows: (string | number)[][]): string {
  return rows.map((row) => row.map(escapeCell).join(',')).join('\n');
}

export function downloadCsv(filename: string, content: string) {
  const blob = new Blob(['\ufeff' + content], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

/** Exportação pontual de um card/gráfico */
export function exportCardCsv(
  slug: string,
  headers: string[],
  rows: (string | number)[][]
) {
  const date = new Date().toISOString().slice(0, 10);
  const csv = rowsToCsv([headers, ...rows]);
  downloadCsv(`conectar-${slug}-${date}.csv`, csv);
}
